import { render, staticRenderFns } from "./icon-pie-chart.vue?vue&type=template&id=1d04c636&"
import script from "./icon-pie-chart.vue?vue&type=script&lang=js&"
export * from "./icon-pie-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports